import LandingSellingPointsSection from './LandingSellingPointsSection';

export default LandingSellingPointsSection;
